import * as React from 'react';
import {Main} from "../components/Main";
import {AplikacjeMobilne} from "../components/sharedComponents/AplikacjeMobilne";
import mobimg from "../images/mmapp.jpg";

interface Props {
}

export const Home = (props: Props) => {
    return (
        <Main active={'HOME'} title={'Strona główna'}>
            <h1 className={'sr-only'}>Karta Stałego Klienta Merkury Market</h1>
            <div style={{height: 'auto'}}>
                <img id={'mobappimg'} style={{width: '100%', marginTop: '0', marginBottom: '10px'}} src={mobimg} className={'img-fluid'}
                     alt={'Aplikacja mobilna Merkury Market na ekranach telefonów. Treść banera znajduje się poniżej.'}/>
            </div>
            <section className={'baner-tekst'} aria-labelledby={'baner-tekst-naglowek'}>
                <h2 id={'baner-tekst-naglowek'} className={'h5'}>Dzięki aplikacji zdobędziesz wiele korzyści!</h2>
                <p><b>Wszystkie informacje w jednym miejscu!</b> Pobierz aplikację i aktywuj dostęp do wersji cyfrowej karty, aby otrzymać zniżki na kolejne zakupy w salonach Merkury Market.</p>
                <ul>
                    <li>Dostęp do aktualnych promocji.</li>
                    <li>Zapakuj kartę do telefonu.</li>
                    <li><b>Gazetki promocyjne?</b> Teraz wszystkie wygodnie pod ręką.</li>
                    <li><b>Nie masz przy sobie karty Stałego Klienta?</b> Teraz wystarczy telefon. Karta dostępna jest po jednym kliknięciu!</li>
                </ul>
            </section>
            <AplikacjeMobilne wersjaPelna={true}/>
        </Main>
    )
}

Home.defaultProps = {}

